import usePageMetadata from '@hooks/usePageMetadata'
import { FunctionComponent } from 'react'
import DesktopGamificationButton from '@components/Buttons/GamificationButton/DesktopGamificationButton'
import MobileGamificationButton from '@components/Buttons/GamificationButton/MobileGamificationButton'
import useIsEndOfArticle from '@hooks/useIsEndOfArticle'

const GamificationButton: FunctionComponent = () => {
  const { gamification } = usePageMetadata()
  const endOfArticle = useIsEndOfArticle()

  if (gamification?.active) {
    return (
      <>
        <DesktopGamificationButton {...gamification} />
        {!endOfArticle && <MobileGamificationButton {...gamification} />}
      </>
    )
  }

  return null
}

export default GamificationButton
